module.exports = __webpack_public_path__ + "static/img/loading.c5756ce2.gif";